import { render, staticRenderFns } from "./ProfitLoss.vue?vue&type=template&id=2af232a2&scoped=true&"
import script from "./ProfitLoss.vue?vue&type=script&lang=ts&"
export * from "./ProfitLoss.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af232a2",
  null
  
)

export default component.exports